import { render, staticRenderFns } from "./u-scrolldown-mouse.vue?vue&type=template&id=325f8b4d&scoped=true"
import script from "./u-scrolldown-mouse.vue?vue&type=script&lang=js"
export * from "./u-scrolldown-mouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325f8b4d",
  null
  
)

export default component.exports